import { FC } from 'react';

import { IconProps } from './types';

export const PlayMiniIcon: FC<IconProps> = ({ color = '#06519E', height = 9, size, width = 8 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 8 9"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M.507 7.92c.153.09.323.13.493.13.178 0 .356-.05.515-.14l5-3a1.007 1.007 0 0 0 0-1.72l-5-3A1.004 1.004 0 0 0 0 1.05v6c0 .36.193.69.506.87"
		/>
	</svg>
);
